import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Point } from '../../../helpers/constants';
import { convertToNorthAngleInRadians } from '../../../utils/math.util';
import HookablePoint from '../HookablePoint';

// const angleToRadians = (angle: number) => (angle * Math.PI) / 180;

const getLinePath = (
  startAngle: number,
  endAngle: number,
  center: Point,
  outerRadius: number,
  innerRadius: number,
  largeArcFlag: number = 0,
  sweepFlag: number = 0
) => {
  const startPoint = {
    x:
      center.x +
      outerRadius * Math.sin(convertToNorthAngleInRadians(startAngle)),
    y:
      center.y +
      outerRadius * Math.cos(convertToNorthAngleInRadians(startAngle)),
  };
  const endPoint = {
    x:
      center.x + outerRadius * Math.sin(convertToNorthAngleInRadians(endAngle)),
    y:
      center.y + outerRadius * Math.cos(convertToNorthAngleInRadians(endAngle)),
  };

  const innerStartPoint = {
    x:
      center.x +
      innerRadius * Math.sin(convertToNorthAngleInRadians(startAngle)),
    y:
      center.y +
      innerRadius * Math.cos(convertToNorthAngleInRadians(startAngle)),
  };
  const innerEndPoint = {
    x:
      center.x + innerRadius * Math.sin(convertToNorthAngleInRadians(endAngle)),
    y:
      center.y + innerRadius * Math.cos(convertToNorthAngleInRadians(endAngle)),
  };

  // A rx ry x-axis-rotation large-arc-flag sweep-flag x y
  // a rx ry x-axis-rotation large-arc-flag sweep-flag dx dy

  const outerArcPath = `A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} ${sweepFlag} ${endPoint.x} ${endPoint.y}`;
  const innerArcPath = `A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} ${sweepFlag} ${innerStartPoint.x} ${innerStartPoint.y}`;
  return `M ${innerStartPoint.x} ${innerStartPoint.y} L ${startPoint.x} ${startPoint.y} ${outerArcPath} L ${innerEndPoint.x} ${innerEndPoint.y} ${innerArcPath}`;
};

export function CircularSector(props: any) {
  const {
    x,
    y,
    arn,
    innerCircleRadius,
    innerCircleLineType,
    innerCircleLineColor,
    outerCircleRadius,
    outerCircleLineType,
    outerCircleLineColor,
    sectorBearings,
    latitude,
    longitude,
    hookProperties,
    centerVisible,
    largeArcFlag,
    sweepFlag,
  } = props;
  const bearingLines = sectorBearings;

  const [isHooked, setIsHooked] = useState({
    isPrimaryHooked: false,
    isSecondaryHooked: false,
  });
  const { primaryHookId, secondaryHookId } = useSelector(
    (state: any) => state.executor.hookedItems
  );
  useEffect(() => {
    setIsHooked({
      isPrimaryHooked: primaryHookId === arn,
      isSecondaryHooked: secondaryHookId === arn,
    });
  }, [primaryHookId, secondaryHookId]);
  console.log({ bearingLines });
  return (
    <>
      {/* <circle
        cx={x}
        cy={y}
        r={innerCircleRadius}
        strokeDasharray={innerCircleLineType === 'dashed' ? '3' : '0'}
        fill="none"
        stroke={innerCircleLineColor}
        pointerEvents="visibleStroke"
      />
      <circle
        cx={x}
        cy={y}
        r={outerCircleRadius}
        strokeDasharray={outerCircleLineType === 'dashed' ? '3' : '0'}
        fill="none"
        stroke={outerCircleLineColor}
        pointerEvents="visibleStroke"
      /> */}
      <text
        x={x + 10}
        y={y}
        textAnchor="start"
        stroke-width="0.5px"
        font-size="0.5em"
        fill={'yellow'}
      >
        {arn?.toUpperCase()}
      </text>
      {centerVisible && (
        <HookablePoint
          x={x}
          y={y}
          radius={2}
          id={arn}
          latitude={latitude}
          longitude={longitude}
          hookProperties={hookProperties}
        />
      )}
      {bearingLines?.map((bearingLine: any, index: number) => (
        <path
          d={getLinePath(
            bearingLine.startBearing,
            bearingLine.endBearing,
            { x, y },
            outerCircleRadius,
            innerCircleRadius,
            largeArcFlag,
            sweepFlag
          )}
          strokeDasharray={bearingLine.lineType === 'dashed' ? '3' : '0'}
          stroke={bearingLine.lineColor || 'yellow'}
          strokeWidth="2"
          fill={bearingLine.fillingColor || 'yellow'}
          pointerEvents="none"
          key={index}
        />
      ))}
    </>
  );
}
